import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    twoContainers: {
      padding: '0px 5px',
      display: 'flex',
      justifyContent: 'space-between',
    },
    boxGrid: {
      margin: '10px 0px',
      '& .MuiCardActions-root': {
        padding: 0,
      },
    },
    title: {
      alignItems: 'center',
      padding: '7px 10px !important',

      '& .PrivateSwitchBase-root': {
        padding: 0,
      },
      '& .MuiIconButton-root': {
        padding: 0,
        marginRight: 5,
        marginLeft: 7,
      },
    },
    titleText: {
      fontWeight: 500,
      fontSize: 14,
    },
    checkIcon: {
      color: `${palette.green} !important`,
    },
  });
